import React, { useState, useEffect } from "react";
import { Col, Modal, Row, Spinner, Button, } from "react-bootstrap";
import Sidebar from "./Sidebar";
import { HeaderDashboard } from "./HeaderDashboard";
import { Footer } from "../../../../public/containers/footer/Footer";
import logo from "../../../../Images/logo_white_web.png"

import { Cancel_Passes, Cancel_Passes_New_API, Pause_Passes, Studio_add_member, Studio_edit_member, Studio_update_pass_expiry_byid, customer_profile_update, delete_user_clover_saved_card_API, family_member_purchase_details, free_passes_list, getCurrentPassesRecordAPI, getNewCustomerAttendanceAPI, get_customer_profile, get_new_customer_profile, get_relations, get_user_clover_saved_card_API, get_user_family_clover_saved_card_API, punch_card_stop_recuring_API, search_customer_details, search_customer_profile_details, studio_country_list, toTimestamp, update_email_API, update_pass_expiry, update_pass_remaining_count, utcToLocalTime, waiver_customer, waiver_customer_family } from "../../../../Studio-Services/Studio_Services";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { errorAlert, successAlert } from "../../../../Static_Services/Alertmsg";
import { InputField } from "../../../../sharedComponents/InputField";
import Swal from "sweetalert2";
import AddCardModalNew from "./AddCardModalNew";
import { checkCardExpire } from "../../../../sharedComponents/Helper";
import FamilyMember from "./StudioCustomerProfile/FamilyMember";
import CustomerCloverCards from "./StudioCustomerProfile/CustomerCloverCards";
import ParentsAttendance from "./StudioCustomerProfile/ParentsAttendance";
import ParentPurchasedProducts from "./StudioCustomerProfile/ParentPurchasedProducts";
import ParentActivePurchasedPasses from "./StudioCustomerProfile/ParentActivePurchasedPasses";
import ParentInActivePurchasedPasses from "./StudioCustomerProfile/ParentInActivePurchasedPasses";
import MemberAttendance from "./StudioCustomerProfile/MemberAttendance";
import MemberPurchasedProducts from "./StudioCustomerProfile/MemberPurchasedProducts";
import MemberActivePurchasedPasses from "./StudioCustomerProfile/MemberActivePurchasedPasses";
import MemberInActivePurchasedPasses from "./StudioCustomerProfile/MemberInActivePurchasedPasses";
import PlaceAutoCompleted from "../../../../client-staff/Components/CommanPages/PlaceAutoCompleted";

export default function StudioCustomerProfileNew() {
    const location = useLocation();
    const [loader, setLoader] = useState(false);
    const [show, setShow] = useState(false);
    const [modalContent, setModalContent] = useState('default');

    const [cmNewEmail, setCmNewEmail] = useState();
    const [isWaiver, setIsWaiver] = useState(false);
    const [selectMemberId, setSelectMemberId] = useState(0);
    const [isEmailEdit, setIsEmailEdit] = useState(false);
    const [studioData, setStudioData] = useState();
    const [searchID, setSearchID] = useState();
    const [freePass, setFreePass] = useState();
    const [editProfileModal, setEditProfileModal] = useState(false);
    const [imgURL, setImgURL] = useState();
    const [selectedFile, setSelectedFile] = useState();
    const [countryList, setCountryList] = useState();
    const [cloverCards, setCloverCards] = useState([]);
    const [child_ID, setChild_ID] = useState('');
    const [summaryData, setSummaryData] = useState();
    const [showModalAttendance, setShowModalAttendance] = useState(false);
    const [parentsAttendance, setParentsAttendance] = useState();

    const [familyProductItems, setFamilyProductItems] = useState([]);
    const [familyUserDetail, setFamilyUserDetail] = useState([]);

    const [familyRecurringActivePunch, setFamilyRecurringActivePunch] = useState([]);
    const [familyPunchItems, setFamilyPunchItems] = useState([]);
    const [familyTimeFrameItems, setFamilyTimeFrameItems] = useState([]);
    const [familyRecurringItems, setFamilyRecurringItems] = useState([]);


    const [familyRecurringInActivePunch, setFamilyRecurringInActivePunch] = useState([]);
    const [familyPunchInactiveItem, setFamilyPunchInactiveItem] = useState([]);
    const [familyTimeFrameInactiveItem, setFamilyTimeFrameInactiveItem] = useState([]);
    const [familyRecurringInactiveItem, setFamilyRecurringInactiveItem] = useState([]);

    const [recurringPassObj, setRecurringPassObj] = useState();
    const [recurringId, setRecurringId] = useState();


    const [pauseCaseValue, setPauseCaseValue] = useState({ "pauseStartDate": '', "days": '', "pauseEndDate": '' });
    const [pauseCaseValueError, setPauseCaseValueError] = useState({ "pauseStartDate": '', "days": '', "pauseEndDate": '' });
    const [selectPunch, setSelectPunch] = useState();
    const [total_count, setTotal_count] = useState(0);
    const [remaining_count, setRemaining_count] = useState(0);
    const [selectPassType, setSelectPassType] = useState();
    const [notClose, setNotClose] = useState(false);
    const [selectPassExpiry, setSelectPassExpiry] = useState();

    const [purchaseRecurringPass, setPurchaseRecurringPass] = useState();
    const [purchaseTimeFramePass, setPurchaseTimeFramePass] = useState();
    const [purchasePunchCardPassRecurring, setPurchasePunchCardPassRecurring] = useState();
    const [purchasePunchCardPass, setPurchasePunchCardPass] = useState();

    const [purchasePunchInactiveCard, setPurchasePunchInactiveCard] = useState();
    const [purchasePunchInactiveCardRecurring, setPurchasePunchInactiveCardRecurring] = useState();
    const [purchaseTimeFrameInactiveCard, setPurchaseTimeFrameInactiveCard] = useState();
    const [purchaseRecurringInactiveCard, setPurchaseRecurringInactiveCard] = useState();
    const [updateModal, setUpdateModal] = useState(false);
    const [recurringPunchCardExpDate, setRecurringPunchCardExpDate] = useState();
    const [recurringpassId, setRecurringpassId] = useState();

    // const [recurringPassId, setRecurringPassId] = useState();


    const [passEditDate, setPassEditDate] = useState();
    const [countModal, setCountModal] = useState(false);
    const [passEXPState, setPassEXPState] = useState(false);
    const [punchConfirmShow, setPunchConfirmShow] = useState({ status: false, data: '', isChild: false });

    const [memberSpinner, setMemberSpinner] = useState(false);
    const [memberDetail1, setMemberDetail1] = useState();
    const [memberDetail1My, setMemberDetail1My] = useState({ memeber_id: '', member_name: '', dob: '', gender: '', relation: '' });
    const [memberDetail1MyError, setMemberDetail1MyError] = useState({ memeber_id: '', member_name: '', dob: '', gender: '', relation: '' });
    const [showCardModal, setShowCardModal] = useState(false);
    const [punchCardSpinner, setPunchCardSpinner] = useState(false);
    const [notclose, setNotclose] = useState(false);
    const [relationIds, setRelationIds] = useState();
    const [relationCollection, setRelationCollection] = useState([]);


    const newFamilyAdd = () => {
        setMemberDetail1My({ memeber_id: '', member_name: '', dob: '', gender: '', relation: '' });
        setUpdateModal(true)
        setRelationIds();
        setImgURL();
    }



    const familyWaiver = (id, name, e, parentEmail) => {
        const isChecked = e.target.checked;
        // const { pass_id, pass_type_id, amount } = freePass;
        const { become_member } = studioData;
        if (!id || !name || !parentEmail) { errorAlert("something wrong "); return; }
        const finalData = {
            'cust_id': id,
            'cust_status': isChecked ? 1 : 0,
            'parentEmail': parentEmail,
            'fullName': name,
            'service_type': freePass?.pass_type_id,
            'service_id': freePass?.pass_id,
            'amount': freePass?.amount,
            'quantity': 1,
            'client_id': id
        }
        Swal.fire({
            title: '<small>CONFIRMATION</small>',
            icon: 'info',
            html: become_member,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: "YES",
            cancelButtonText: "NO",
            customClass: {
                popup: 'custom-popup', // Custom class for popup
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoader(true);
                const resp = await waiver_customer_family(finalData);
                if (resp) {
                    setLoader(false);
                    Swal.fire({
                        html: `
                            <img src=${logo} class="img-fluid d-block mx-auto mt-5" />
                            <h4 class="title text-capitalize text-center mt-4 textWhite">Success</h4>
                            <p class="text-center my-4 textcolor">
                                <small class="textWhite">${resp?.data?.message}</small>
                            </p>
                            `,
                        showClass: {
                            popup: 'custom-dialog-container',
                        },
                        customClass: {
                            confirmButton: 'custom-button custom-button-size modalbtn',
                        },
                        confirmButtonText: 'OK',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            getProfile();
                        }
                    });
                }
            } else {
                setLoader(false);
            }
            setLoader(false);
        })
        setLoader(false);
    }



    const handleClose = () => {
        setRecurringPassObj();
        setRecurringId();
        setRecurringpassId();
        setShow(false); setModalContent('default');
    };
    const addMembers = async (e) => {
        e.preventDefault();
        const fData = new FormData(e.target);
        const fValue = Object.fromEntries(fData.entries());
        let isValid = 1;

        if (!memberDetail1My.member_name) { isValid = 2; setMemberDetail1MyError((pre) => ({ ...pre, member_name: 'Full Name is required' })) }
        if (!memberDetail1My.dob) { isValid = 3; setMemberDetail1MyError((pre) => ({ ...pre, dob: '* Required' })) }
        if (!memberDetail1My.gender) { isValid = 4; setMemberDetail1MyError((pre) => ({ ...pre, gender: 'Gender is required' })) }
        if (!memberDetail1My.relation) { isValid = 5; setMemberDetail1MyError((pre) => ({ ...pre, relation: 'Please Select Relation' })) }

        // ********** UPDATE OLD MEMBER ************ //

        if (fValue.memeber_id) {
            if (isValid == 1) {
                setMemberSpinner(true);
                let formdata = new FormData();
                formdata.append("fullname", memberDetail1My.member_name);
                formdata.append("dob", memberDetail1My.dob);
                formdata.append("relative_id", memberDetail1My.relation);
                formdata.append("member_id", memberDetail1My.memeber_id);
                formdata.append("gender", memberDetail1My.gender);
                formdata.append("user_id", memberDetail1.relative_id);
                if (selectedFile) {
                    formdata.append("image", selectedFile);
                }
                const resp = await Studio_edit_member(formdata);
                if (resp) {
                    setMemberDetail1My({ memeber_id: '', member_name: '', dob: '', gender: '', relation: '' });
                    setMemberSpinner(true);
                    successAlert(resp.data.message);
                    setMemberSpinner(false);
                    setUpdateModal(false);
                    getProfile();
                } else setMemberSpinner(true);
            }
        } else {
            if (isValid === 1) {
                setMemberSpinner(true);
                let payload = new FormData();
                payload.append("fullname", memberDetail1My.member_name);
                payload.append("dob", memberDetail1My.dob);
                payload.append("relative_id", memberDetail1My.relation);
                payload.append("image", selectedFile);
                payload.append("gender", memberDetail1My.gender);
                payload.append("user_id", searchID);
                const response = await Studio_add_member(payload);
                if (response) {
                    setMemberDetail1My({ memeber_id: '', member_name: '', dob: '', gender: '', relation: '' });
                    successAlert(response.data.message);
                    setMemberSpinner(false);
                    setUpdateModal(false);
                    getProfile();
                } else { setMemberSpinner(false); }
            }
        }
    }

    const ViewDetail = (detail) => {
        setSummaryData(detail);
        setShowModalAttendance(true)
    }

    const currentPassesRecordHandler = async (id = searchID) => {
        if (!id) return;
        const payload = { user_id: id }
        const resp = await getCurrentPassesRecordAPI(payload);
        if (resp) {
            let purchasePass = resp.purchasePassesData;
            if (purchasePass.length > 0) {
                const currentDate = moment().format(' MMMM DD, YYYY');
                let activePassRecords = [];
                let inActivePassRecords = [];

                let activePassPunchRecords = [];
                let inActivePassPunchRecords = [];

                let activeTimeFrameRecords = [];
                let inActiveTimeFrameRecords = [];

                let activeRecurringRecords = [];
                let inActiveRecurringRecords = [];

                purchasePass.forEach(function (value) {
                    if (value.pass_type_name == 'Punch Card') {
                        const endDate = Number(value.end_date_utc);
                        const convert = moment.unix(endDate).format(' MMMM DD, YYYY');
                        const count = value.passes_remaining_count;

                        // isSameOrAfter pehle yahi tha
                        if (value.recurring_date != "") {
                            if (moment(currentDate).isAfter(convert) || count == 0) { inActivePassPunchRecords.push(value); } else { activePassPunchRecords.push(value); }
                        } else {
                            if (moment(currentDate).isAfter(convert) || count == 0) { inActivePassRecords.push(value); } else { activePassRecords.push(value); }
                        }
                    } else if (value.pass_type_name == 'Time Frame') {
                        const endDate = Number(value.end_date_utc);
                        const convert = moment.unix(endDate).format(' MMMM DD, YYYY');
                        if (moment(currentDate).isAfter(convert)) {
                            inActiveTimeFrameRecords.push(value);
                        } else {
                            activeTimeFrameRecords.push(value);
                        }
                    } else if (value.pass_type_name == 'Recurring Membership') {
                        const endDate = Number(value.end_date_utc);
                        const convert = moment.unix(endDate).format(' MMMM DD, YYYY');
                        if (moment(currentDate).isAfter(convert)) {
                            inActiveRecurringRecords.push(value);
                        } else {
                            activeRecurringRecords.push(value);
                        }
                    }
                });
                let purchasePunchCardPassMy = activePassRecords;
                let purchasePunchInactiveCard = inActivePassRecords;

                let purchaseTimeFramePassMy = activeTimeFrameRecords;
                let purchaseTimeFrameInactiveCardMy = inActiveTimeFrameRecords;

                let purchaseRecurringPassMy = activeRecurringRecords;
                let purchaseRecurringInactiveCardMy = inActiveRecurringRecords;
                setPurchasePunchCardPass(purchasePunchCardPassMy)
                setPurchasePunchInactiveCard(purchasePunchInactiveCard);
                setPurchaseTimeFramePass(purchaseTimeFramePassMy);
                setPurchaseTimeFrameInactiveCard(purchaseTimeFrameInactiveCardMy);
                setPurchaseRecurringPass(purchaseRecurringPassMy);
                setPurchaseRecurringInactiveCard(purchaseRecurringInactiveCardMy);

                setPurchasePunchCardPassRecurring(activePassPunchRecords);
                setPurchasePunchInactiveCardRecurring(inActivePassPunchRecords);

            } else {
                setPurchasePunchCardPass([])
                setPurchasePunchInactiveCard([]);
                setPurchaseTimeFramePass([]);
                setPurchaseTimeFrameInactiveCard([]);
                setPurchaseRecurringPass([]);
                setPurchaseRecurringInactiveCard([])
                setPurchasePunchInactiveCardRecurring([]);
                setPurchasePunchCardPassRecurring([]);
            }
        } else {
            setPurchasePunchCardPass([])
            setPurchasePunchInactiveCard([]);
            setPurchaseTimeFramePass([]);
            setPurchaseTimeFrameInactiveCard([]);
            setPurchaseRecurringPass([]);
            setPurchaseRecurringInactiveCard([])
            setPurchasePunchInactiveCardRecurring([]);
            setPurchasePunchCardPassRecurring([]);
        }
    }

    const changePassInfo = (list, type = 1) => {
        setPassEditDate('');

        setSelectPunch(list);
        setTotal_count(list.passes_total_count);
        setRemaining_count(list.passes_remaining_count);
        setSelectPassType(list.pass_type_name);

        setPassEditDate(moment(list.end_date).format(' MMMM DD, YYYY'))
        let milliseconds = list.end_date_utc * 1000;
        setSelectPassExpiry(new Date(milliseconds));
        if (type === 1) {
            setCountModal(true);
        } else { setPassEXPState(true) }
    }


    const changeExPassInfo = (list, type = 1) => {
        setSelectPunch(list);
        setTotal_count(list.passes_total_count);
        setRemaining_count(list.passes_remaining_count);
        setSelectPassType(list.pass_type_name);
        let milliseconds = list.end_date_utc * 1000;
        setSelectPassExpiry(new Date(milliseconds));
        setNotClose(true);
    }


    const changeStatus = (type, passId, id, rowObj = '') => {
        type = 1;
        setRecurringPassObj(rowObj);
        if (rowObj && rowObj.pass_pause_start_less_then_thirty) {
            setPauseCaseValue((pre) => ({ ...pre, pauseStartDate: rowObj.pass_pause_start_less_then_thirty }));
        }
        localStorage.setItem('pass_recurring_pause', JSON.stringify(rowObj));
        setRecurringId(id);
        setRecurringpassId(passId);
        setShow(true);
    }




    const [cmProfile, setCmProfile] = useState({
        name: '', lastName: '', email: '', state: '',
        date_of_birth: '', city: '', country_code: '', address: '',
        mobile: '', country: '', emergency_country_code: '',
        emergency_contact_no: '', gender: '', emergency_contact_person: ''
    })
    const [eFormData, setEFormData] = useState({
        name: '', lastName: '', email: '', state: '',
        date_of_birth: '', city: '', country_code: '', address: ''
        , mobile: '', country: '', emergency_country_code: '',
        emergency_contact_no: '', gender: '', emergency_contact_person: ''
    })


    const freePassesHandler = async () => {
        const passPre = { "page_no": "1" }
        const resp = await free_passes_list(passPre);
        if (resp) {
            const data = resp?.data?.data[0];
            setFreePass(data);
        }
    }

    const getAttendanceHandler = async (id = searchID) => {
        const payload = { user_id: id };
        const resp = await getNewCustomerAttendanceAPI(payload);
        if (resp) {
            const data = resp.data.data;
            setParentsAttendance(data.attendance);
        } else {
            setCmProfile()
        }

    }
    const getProfile = async (id = searchID) => {
        const payload = { user_id: id };
        const resp = await get_new_customer_profile(payload);
        if (resp) {
            const data = resp.data.data;
            if (data.waiver == 1) { setIsWaiver(true); } else { setIsWaiver(false); }
            const object = {
                ...data,
                profile_img: data.profile_img,
                name: data.name,
                lastName: data.lastname,
                email: data.email,
                state: data.state,
                date_of_birth: data.date_of_birth,
                city: data.city,
                country_code: data.country_code,
                address: data.address,
                mobile: data.mobile,
                country: data.country,
                emergency_country_code: data.emergency_country_code,
                emergency_contact_no: data.emergency_contact_no,
                gender: data.gender,
                emergency_contact_person: data.emergency_contact_person
            }
            currentPassesRecordHandler(id);
            setCmProfile(object);
            setCmNewEmail(data.email);
        } else { setCmProfile() }
    }

    const getCustomerCloverCard = async (id = searchID) => {
        if (!id) { return; }
        const payload = { client_id: id, };
        setLoader(true);
        try {
            const response = await get_user_clover_saved_card_API(payload);
            if (response) {
                setCloverCards(response.data);
            } else {
                setCloverCards([]);
            }
        } catch (error) {
            console.log("=====@Error=======", error);
        } finally {
            setLoader(false);
        }
    };

    const getRelation = async () => {
        const resp = await get_relations();
        if (resp) {
            setRelationCollection(resp.data.data);
        } else {
            setRelationCollection([])
        }
    }

    const getCountry = async () => {
        let cd = '';
        const resp = await studio_country_list();
        if (resp) {
            let response = resp.data;
            response.data.map((el) => {
                if (el.name == "United States") {
                    cd = el.name + " (" + el.code + ")";
                }
            });
            setCountryList(response.data);
            // let abc = cmProfile;
            // abc.emergency_country_code = cd;
            // setCmProfile(abc);
        }
    }

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem("st_userData"));
        if (userData) { setStudioData(userData); }
        if (location.state) {
            // setGetCtomerDetail(location.state);
            // setUserID(location.state);
            // setGetCustomerDetail(location.state);
            getRelation();
            getCountry();
            const { id } = location?.state;
            if (id) { setSearchID(id); getCustomerCloverCard(id) }
            freePassesHandler();
            getProfile(id);
            getAttendanceHandler(id);

            getCountryHandler();
        }
    }, [location])


    const emailUpdateHandler = async (eId, oldEmail) => {
        setIsEmailEdit(false);
        setLoader(true);
        if (!eId) { errorAlert("Email ID is required"); return; }
        if (!oldEmail) { errorAlert("Email ID is required"); return; }
        const payload = { "newEmail": eId, "email": oldEmail }
        const resp = await update_email_API(payload);
        if (resp) {
            getProfile();
            setLoader(false);
            successAlert(resp.data.message);
        } else {
            setLoader(false);
        }
    }

    const waiverHandler = (e) => {
        // const isChecked = e.target.checked;
        // const { become_member } = studioData;
        // setIsWaiver(isChecked);

        // const payload = {
        //     'cust_id': clientIDS,
        //     'cust_status': isChecked ? 1 : 0,
        //     'service_type': freePass?.pass_type_id,
        //     'service_id': freePass?.pass_id,
        //     'amount': freePass?.amount,
        //     'quantity': 1,
        //     'client_id': clientIDS
        // }

        // Swal.fire({
        //     title: '<small>CONFIRMATION</small>',
        //     icon: 'info',
        //     html: become_member,
        //     showCloseButton: true,
        //     showCancelButton: true,
        //     focusConfirm: false,
        //     confirmButtonText: "YES",
        //     cancelButtonText: "NO",
        //     customClass: {
        //         popup: 'custom-popup', // Custom class for popup
        //     }
        // }).then(async (result) => {
        //     if (result.isConfirmed) {
        //         setLoader(true);
        //         const resp = await waiver_customer(payload);
        //         if (resp) {
        //             setLoader(false);
        //             Swal.fire({
        //                 html: `
        //           <img src=${logo} class="img-fluid d-block mx-auto mt-5" />
        //           <h4 class="title text-capitalize text-center mt-4 textWhite">Success</h4>
        //           <p class="text-center my-4 textcolor">
        //             <small class="textWhite">${resp.data.message}</small>
        //           </p>
        //         `,
        //                 showClass: {
        //                     popup: 'custom-dialog-container',
        //                 },
        //                 customClass: {
        //                     confirmButton: 'custom-button custom-button-size modalbtn',
        //                 },
        //                 confirmButtonText: 'OK',
        //             }).then((result) => {
        //                 if (result.isConfirmed) {
        //                     getProfile();
        //                 }
        //             });
        //         }
        //     } else {
        //         setLoader(false);
        //         setIsWaiver(!isChecked);
        //     }
        //     setLoader(false);
        // })
        // setLoader(false);
    }


    const updateProfileHandler = async () => {

        let isValid = 1;

        if (!cmProfile.name) { isValid = 2; setEFormData((pre) => ({ ...pre, name: 'First Name is required' })) }
        if (!cmProfile.lastName) { isValid = 3; setEFormData((pre) => ({ ...pre, lastName: 'Last Name is required' })) }
        if (!cmProfile.state) { isValid = 4; setEFormData((pre) => ({ ...pre, state: 'State is required' })) }
        if (!cmProfile.date_of_birth) { isValid = 5; setEFormData((pre) => ({ ...pre, date_of_birth: 'Date of Birth is required' })) }
        if (!cmProfile.city) { isValid = 6; setEFormData((pre) => ({ ...pre, city: '' })) }
        if (!cmProfile.country_code) { isValid = 7; setEFormData((pre) => ({ ...pre, country_code: '' })) }
        if (!cmProfile.address) { isValid = 8; setEFormData((pre) => ({ ...pre, address: 'Address is required' })) }
        if (!cmProfile.mobile) { isValid = 9; setEFormData((pre) => ({ ...pre, mobile: '' })) }
        if (!cmProfile.country) { isValid = 10; setEFormData((pre) => ({ ...pre, country: 'Country is required' })) }
        // if (!cmProfile.emergency_country_code) { isValid = 11; setEFormData((pre) => ({ ...pre, emergency_country_code: '' })) }
        if (!cmProfile.emergency_contact_no) { isValid = 12; setEFormData((pre) => ({ ...pre, emergency_contact_no: 'Emergency Contact Number is required' })) }
        if (!cmProfile.gender) { isValid = 13; setEFormData((pre) => ({ ...pre, gender: '' })) }
        if (!cmProfile.emergency_contact_person) { isValid = 15; setEFormData((pre) => ({ ...pre, emergency_contact_person: 'Emergency Contact Person is required' })) }

        if (isValid === 1) {
            setLoader(true);
            var formData = new FormData();
            formData.append("user_id", cmProfile.id);
            formData.append("name", cmProfile.name);
            formData.append("lastname", cmProfile.lastname);
            formData.append("gender", cmProfile.gender);
            formData.append("date_of_birth", cmProfile.date_of_birth);
            formData.append("address", cmProfile.address);
            formData.append("city", cmProfile.city);
            formData.append("state", cmProfile.state);
            formData.append("country", cmProfile.country);
            formData.append("about", cmProfile.about);
            formData.append("zipcode", cmProfile.zipcode);
            formData.append("lat", cmProfile.lat);
            formData.append("lang", cmProfile.lang);
            formData.append("street", cmProfile.street);
            if (!imgURL) {
                formData.append("image", cmProfile.profile_img);
            } else {
                formData.append("image", selectedFile);
            }
            // formData.append('image',this.imgURL);
            formData.append("role_id", cmProfile.role_id);
            formData.append("mobile", cmProfile.mobile);
            formData.append("country_code", cmProfile.country_code);
            formData.append("emergency_contact_person", cmProfile.emergency_contact_person);
            formData.append("emergency_country_code", cmProfile.emergency_country_code);
            formData.append("emergency_contact_no", cmProfile.emergency_contact_no);
            formData.append("skills", cmProfile.skill);
            formData.append("experience", cmProfile.experience);
            try {
                const resp = await customer_profile_update(formData);
                if (resp) {
                    setLoader(false);
                    setImgURL();
                    setEditProfileModal(false);
                    getProfile();
                    successAlert(resp.data.message);
                }
            } catch (error) {
                console.log("------@Error-----", error);
            } finally {
                setEditProfileModal(false);
                setLoader(false);
            }

        }
    }



    const prOnChange = (e) => {
        const { name, value } = e.target;
        setEFormData((pre) => ({ ...pre, [name]: '' }));
        setCmProfile((pre) => ({ ...pre, [name]: value }));
    }

    //  * get Upload image detail *//
    const getUploadFileDetail = (event) => {
        if (event.target.files.length > 0) {
            setSelectedFile(event.target.files[0]);
            var mimeType = event.target.files[0].type;
            if (mimeType.match(/image\/*/) == null) {
                console.log("Only images are supported.");
                return;
            }
            var reader = new FileReader();
            // setImagePath(event.target.files);
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = (_event) => {
                setImgURL(reader.result);
            };
        }
    }

    const getCountryHandler = async () => {
        let cd = '';
        const resp = await studio_country_list();
        if (resp) {
            let response = resp.data;
            response.data.map((el) => {
                if (el.name == "United States") {
                    cd = el.name + " (" + el.code + ")";
                }
            });
            setCountryList(response.data);
        }
    }

    const getCustomerFamilyCloverCard = async (id) => {
        if (!searchID) { return; }
        const payload = { client_id: id };
        setLoader(true);
        try {
            const response = await get_user_family_clover_saved_card_API(payload);
            if (response) {
                setCloverCards(response.data);
            } else {
                setCloverCards([]);
            }
        } catch (error) {
            console.log("=====@Error=======", error);
        } finally {
            setLoader(false);
        }
    };


    const viewFamilyPass = async (memberId) => {
        if (!memberId) { return };
        setSelectMemberId(memberId);
        let payload = {
            parentId: searchID,
            memberId: memberId
        };
        const response = await family_member_purchase_details(payload);
        if (response) {
            getCustomerFamilyCloverCard(memberId);
            let data = response.data.data;
            setFamilyProductItems(data.product);
            setFamilyUserDetail(data.attendance);
            const currentDate = moment().format(' MMMM DD, YYYY');

            let activePassRecords = [];
            let inActivePassRecords = [];
            let activeRecurringPunch = [];
            let inActiveRecurringPunch = [];

            data.punch.forEach(function (value) {
                const endDate = Number(value.end_date_utc);
                const convert = moment.unix(endDate).format(' MMMM DD, YYYY');
                const count = value.passes_remaining_count;
                if (value.recurring_date != "") {
                    if (moment(currentDate).isAfter(convert) || count == 0) { inActiveRecurringPunch.push(value); } else { activeRecurringPunch.push(value); }
                } else {
                    if (moment(currentDate).isAfter(convert) || count == 0) { inActivePassRecords.push(value); } else { activePassRecords.push(value); }
                }
            });

            setFamilyRecurringActivePunch(activeRecurringPunch);
            setFamilyRecurringInActivePunch(inActiveRecurringPunch);

            setFamilyPunchItems(activePassRecords);
            setFamilyPunchInactiveItem(inActivePassRecords);

            let activeTimeFrameRecords = [];
            let inActiveTimeFrameRecords = [];

            data.time.forEach(function (value) {
                const endDate = Number(value.end_date_utc);
                const convert = moment.unix(endDate).format(' MMMM DD, YYYY');
                if (moment(currentDate).isAfter(convert)) {
                    inActiveTimeFrameRecords.push(value);
                } else {
                    activeTimeFrameRecords.push(value);
                }
            });

            setFamilyTimeFrameItems(activeTimeFrameRecords);
            setFamilyTimeFrameInactiveItem(inActiveTimeFrameRecords);

            let activeRecurringRecords = [];
            let inActiveRecurringRecords = [];

            data.recurring.forEach(function (value) {
                const endDate = Number(value.end_date_utc);
                const convert = moment.unix(endDate).format(' MMMM DD, YYYY');
                if (moment(currentDate).isAfter(convert)) {
                    inActiveRecurringRecords.push(value);
                } else {
                    activeRecurringRecords.push(value);
                }
            });

            setFamilyRecurringItems(activeRecurringRecords);
            setFamilyRecurringInactiveItem(inActiveRecurringRecords);
            setLoader(false);

        } else {
            setLoader(false)
            setFamilyProductItems([]);
            setFamilyPunchItems([]);
            setFamilyRecurringActivePunch([]);
            setFamilyRecurringInActivePunch([]);
            setFamilyTimeFrameItems([]);
            setFamilyRecurringItems([]);
            setFamilyPunchInactiveItem([]);
            setFamilyTimeFrameInactiveItem([]);
            setFamilyRecurringInactiveItem([]);
            setFamilyUserDetail();
        }
        setLoader(false);
    }

    const resetFamilyPass = () => {
        setSelectMemberId(0);
        setFamilyProductItems([]);
        setFamilyPunchItems([]);
        setFamilyRecurringActivePunch([]);
        setFamilyUserDetail();
        setFamilyTimeFrameItems([]);
        setFamilyRecurringItems([]);
        setFamilyRecurringInActivePunch([]);
        setFamilyRecurringInactiveItem([]);
        setFamilyPunchInactiveItem([]);
        setFamilyTimeFrameInactiveItem([]);
    }


    const update = (detail) => {
        let membDetail1 = detail;
        let relative_id = ''
        for (let i = 0; i < relationCollection.length; i++) {
            if (relationCollection[i].realtion_name == membDetail1.relation) {
                setRelationIds(relationCollection[i].relative_id);
                relative_id = relationCollection[i].relative_id;

            }
        }
        setImgURL(detail.image);
        setUpdateModal(true);
        setMemberDetail1(membDetail1);
        setMemberDetail1My({ memeber_id: membDetail1.memeber_id, member_name: membDetail1.member_name, dob: membDetail1.dob, gender: membDetail1.gender, relation: relative_id });
    }



    const faminlyOnChange = (e) => {
        const { name, value } = e.target;
        setMemberDetail1MyError((pre) => ({ ...pre, [name]: '' }));
        setMemberDetail1My((pre) => ({ ...pre, [name]: value }));
    }


    const cancelPausePass = async () => {
        let monthEndDate = moment().endOf('month').add(1, 'day').format('YYYY-MM-DD');
        if (['36', '37'].includes(recurringPassObj?.pass_type_subcat)) {
            monthEndDate = moment()
                .endOf('month')
                .add(1, 'day')
                .format('YYYY-MM-DD');
        } else {
            monthEndDate = moment(recurringPassObj.end_date)
                .add(1, 'day')
                .format('YYYY-MM-DD');
        }

        const userID = selectMemberId === 0 ? cmProfile.id : selectMemberId;
        const businessIS = recurringPassObj.business_id;
        const finalData = {
            "user_id": userID,
            "business_id": businessIS,
            "pass_id": recurringpassId,
            "id": recurringId,
            "cancel_date": monthEndDate,
        }


        const resp = await Cancel_Passes_New_API(finalData);
        if (resp) {
            successAlert(resp.data.message);
            getProfile();
            setShow(false);
            setRecurringPassObj();
            setRecurringId();
            setRecurringpassId();
        }
    }



    const confirmMultipleResponse = async () => {
        if (recurringPassObj && recurringPassObj.pass_pause_start_less_then_thirty == '') {
            if (pauseCaseValue && pauseCaseValue.pauseStartDate === '') {
                errorAlert('Plese Select Pause Start Date');
                return;
            }
            if (pauseCaseValue && pauseCaseValue.days === '') {
                errorAlert('Days Paused (must be less than 30 days)'); return;
            }

            const startDates = pauseCaseValue.pauseStartDate;
            const selectedDay = pauseCaseValue.days;
            const endDates = checkLessThenThirty(selectedDay);
            if (!endDates) { return; }
            const userID = selectMemberId === 0 ? cmProfile.id : selectMemberId;
            const businessID = recurringPassObj.business_id;
            const finalData = {
                "user_id": userID,
                "business_id": businessID,
                "pass_id": recurringpassId,
                "id": recurringId,
                "schedule_date": startDates,
                "schedule_end_date": endDates,
                "days": selectedDay
            }
            const resp = await Pause_Passes(finalData);
            if (resp) {
                successAlert(resp.data.message);
                getProfile();
                setShow(false);
                setRecurringPassObj();
                setRecurringId();
                setRecurringpassId();
            }
        } else {
            const startDates = pauseCaseValue.pauseStartDate;
            const endDates = pauseCaseValue.pauseEndDate;
            const userID = selectMemberId === 0 ? cmProfile.id : selectMemberId;
            const businessIS = recurringPassObj.business_id;
            const diffday = getDays(startDates, endDates);
            if (!diffday) { return; };
            const finalData = {
                "user_id": userID,
                "business_id": businessIS,
                "pass_id": recurringpassId,
                "id": recurringId,
                "schedule_date": startDates,
                "schedule_end_date": endDates,
                "days": diffday
            }
            const resp = await Pause_Passes(finalData);
            if (resp) {
                successAlert(resp.data.message);
                getProfile();
                setShow(false);
                setRecurringPassObj();
                setRecurringId();
                setRecurringpassId();
            }
        }
    }

    const checkLessThenThirty = (days) => {
        const preDate = moment(pauseCaseValue.pauseStartDate).format('YYYY-MM-DD');
        const nextDate = moment(preDate).add(days, 'day').format('YYYY-MM-DD');

        const differenceInDays = moment(nextDate).diff(preDate, 'days');
        if (differenceInDays < 30) {
            return nextDate;
        } else { errorAlert('Please enter less then 30 days'); return false; }
    }

    const getDays = (pre, past) => {
        const startDate = moment(pre);
        const endDate = moment(past);
        const differenceInDays = endDate.diff(startDate, 'days');
        if (differenceInDays < 30) {
            return differenceInDays;
        } else { errorAlert('Please enter less then 30 days'); return false; }

    }

    const changeHandlerPause = (e) => {
        const { name, value } = e.target;
        setPauseCaseValue((pre) => ({ ...pre, [name]: value }));
        setPauseCaseValueError((pre) => ({ ...pre, [name]: '' }));
    }

    const stopRecuringHandler = async (data, child) => {

        if (!data?.user_booking_id) {
            errorAlert("Booking id is required");
            return;
        }
        let cancel_date = "";
        if (data.end_date_utc) {
            cancel_date = moment.unix(data.end_date_utc).format("YYYY-MM-DD");
        } else {
            errorAlert("The pass end date is required");
        }
        const payload = {
            'user_booking_id': data.user_booking_id,
            'cancel_date': cancel_date,

        };
        setLoader(true);
        try {
            const resp = await punch_card_stop_recuring_API(payload);
            Swal.fire({
                title: resp.data.status == 1 ? "Success!" : "Error!",
                text: resp.data.message,
                icon: resp.data.status == 1 ? "success" : "error"
            }).then(async (result) => {
                if (result.isConfirmed) {
                    if (child && child_ID) {
                        viewFamilyPass(child_ID);
                    }
                    getProfile();
                }
            });
        } catch (error) {
            console.log("@error", error);
            Swal.fire({
                title: "Error!",
                text: "Something went wrong",
                icon: "error"
            });
        } finally {
            setLoader(false);

        }
    };

    const handleButtonClick = (action) => {
        if (action === 'Cancel') {
            setModalContent('cancel');
        } else if (action === 'Pause') {
            setModalContent('pause');
        }
    };

    const updateExPassDate = async () => {
        if (passEditDate == undefined) {
            errorAlert("Please select expiry date first");
        } else {
            let payload = {
                id: selectPunch.user_booking_id,
                pass_expired_date: moment(passEditDate).unix()
            };
            setPunchCardSpinner(true);
            const response = await Studio_update_pass_expiry_byid(payload);
            if (response) {
                setNotclose(false);
                setPassEditDate();
                setPunchCardSpinner(false);
                setSelectPunch();
                setTotal_count();
                setRemaining_count();
                setSelectPassType();
                successAlert(response.data.message);
                if (selectMemberId == 0) {
                    getProfile();
                } else {
                    viewFamilyPass(selectMemberId);
                }
            } else setPunchCardSpinner(false);
        }

    }


    const updatePassDate = async () => {
        if (passEditDate == undefined) {
            errorAlert("Please select expiry date first");
        } else {

            const pass_exp_date = moment(passEditDate).unix();

            const payload = {
                'id': selectPunch.user_booking_id,
                'exp_date': pass_exp_date
            }

            // tempObj.exp_date = toTimestamp((new Date(passEditDate)));

            setPunchCardSpinner(true);
            const response = await update_pass_expiry(payload);
            if (response) {
                setPunchCardSpinner(false);
                successAlert(response.data.message);
                setPassEXPState(false);

                setSelectPunch();
                setTotal_count();
                setRemaining_count();
                setSelectPassType();
                if (selectMemberId == 0) {
                    getProfile();
                } else {
                    viewFamilyPass(selectMemberId);
                }
            }
            setPunchCardSpinner(false);
        }
    }

    const updatePassCounter = async () => {

        // alert('Hello');return;
        const total = total_count;
        // const remaining_count = remaining_count;
        // const selectPunch = selectPunch;

        let tempObject = {};
        tempObject.user_booking_id = selectPunch.user_booking_id;
        tempObject.pass_type = selectPunch.pass_type_name;

        if (selectPunch.pass_type_name === "Punch Card") {
            // convert to moment (multiply by 1000 since JS uses ms)

            if (recurringPunchCardExpDate) {
                const expDate = moment(recurringPunchCardExpDate * 1000);
                const now = moment();
                if (expDate.isBefore(now)) {
                    errorAlert("❌ Cannot add a punch. Please update the expiration date first, as it must be greater than the current date before adding punches.");
                    return;
                }
            }


            if (+remaining_count > +total) {
                errorAlert("The remaining count should be equal to or less than to Total Count.");
                return false;
            }
            tempObject.passes_total_count = total;
            tempObject.passes_remaining_count = remaining_count;
        } else {
            const expiry_date = toTimestamp(selectPassExpiry);
            tempObject.passes_expiry_date = expiry_date;
        }
        setPunchCardSpinner(true);

        // this.business_service
        const response = await update_pass_remaining_count(tempObject);
        if (response) {
            setSelectPunch();
            setTotal_count();
            setRemaining_count();
            setSelectPassType();
            setPunchCardSpinner(false);
            setCountModal(false);
            successAlert(response.data.message);
            if (selectMemberId == 0) {
                getProfile();
            } else {
                viewFamilyPass(selectMemberId);
            }
        }
        setPunchCardSpinner(false);
    }

    const [coordinates, setCoordinates] = useState();

    useEffect(() => {
        if (!coordinates) return;

        const updates = {
            address: coordinates.getAddress,
            city: coordinates.getCity,
            state: coordinates.getState,
            country: coordinates.getCountry,
            zipcode: coordinates.getZIP_Code,
            street: coordinates.getLocation_name,
            lat: coordinates.getLat,
            lang: coordinates.getLng,
        };

        // Only update fields having a selected value
        const validUpdates = Object.fromEntries(
            Object.entries(updates).filter(
                ([, value]) => value !== undefined && value !== null && value !== ''
            )
        );

        if (Object.keys(validUpdates).length === 0) return;

        setCmProfile((prev) => {
            const hasChanges = Object.entries(validUpdates).some(
                ([key, value]) => prev?.[key] !== value
            );

            return hasChanges ? { ...prev, ...validUpdates } : prev;
        });

        setEFormData((prev) => {
            const hasChanges = Object.keys(validUpdates).some(
                (key) => prev?.[key] !== ''
            );

            if (!hasChanges) return prev;

            return {
                ...prev,
                ...Object.fromEntries(
                    Object.keys(validUpdates).map((key) => [key, ''])
                ),
            };
        });
    }, [coordinates, setCmProfile, setEFormData]);



    return (
        <>
            {loader && <div className='MainLoader'>
                <Spinner animation="border" role="status" className='Loader' />
            </div>}

            <div className="MainDashboard">
                <div className="MainLayout">
                    <Row>
                        <Sidebar />
                        <Col className="p-0 RightCol">
                            <HeaderDashboard />
                            <div className="RightSide pr-2" style={{ maxWidth: '99%' }}>
                                <div className="page-content-wrapper" id="mainpageWrapper">
                                    <div className="page-content-inner bg-brand-dark mt-3 py-3 pl-4">
                                        <section className="contentSections mt-5">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="right-productdetail-sec p-4 relative mt-5 customer-section">
                                                        <div className="row mx-0 align-items-center">
                                                            <div className="col-md-2">
                                                                <div className="user-profile-img">
                                                                    {cmProfile?.profile_img &&
                                                                        <img src={cmProfile.profile_img} className="img-fluid" alt="profile image" />
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="col-md-10">

                                                                <div className="selected-user-detail pl-3">
                                                                    <h4 className="text-capitilize mb-1">Name: {cmProfile?.name}</h4>
                                                                    <span className="brand-light">Customer</span>
                                                                    <p className="mb-0">DOB: {cmProfile && moment(cmProfile?.date_of_birth).format(' MMMM DD, YYYY')}</p>
                                                                    {!isEmailEdit ?
                                                                        <p className="mt-1 mb-0">Email: {cmProfile?.email} <button
                                                                            type="button"
                                                                            className="fa fa-edit"
                                                                            data-toggle="modal"
                                                                            data-target="#passInfoExpireDateModel"
                                                                            onClick={() => { setIsEmailEdit(true) }}
                                                                            style={{ fontSize: "22px" }}
                                                                        ></button></p>
                                                                        :
                                                                        <>
                                                                            <div className="form-group d-flex" style={{ alignItems: 'center' }}>

                                                                                <p className="black-color font-w-900 font-18  me-2"> Email </p>
                                                                                <input
                                                                                    id=""
                                                                                    type="email"
                                                                                    name="email"
                                                                                    className="form-control"
                                                                                    value={cmNewEmail}
                                                                                    onChange={(e) => { setCmNewEmail(e.target.value) }}
                                                                                    style={{ backgroundColor: "white", width: '300px' }}
                                                                                    placeholder="Enter your e-mail"
                                                                                />
                                                                                <button
                                                                                    type="button"
                                                                                    className="fa fa-check-square ms-2"
                                                                                    data-toggle="modal"
                                                                                    data-target="#passInfoExpireDateModel"
                                                                                    style={{ fontSize: "24px" }}
                                                                                    onClick={() => { emailUpdateHandler(cmNewEmail, cmProfile?.email); }}
                                                                                ></button>
                                                                            </div>

                                                                        </>

                                                                    }

                                                                    <p className="mt-1 mb-0">Mobile:
                                                                        {(cmProfile.country_code && cmProfile.country_code != undefined) ? cmProfile.country_code : ''}-{cmProfile?.mobile}</p>
                                                                    <p className="mt-1 mb-0">Address:{cmProfile?.address}</p>
                                                                    <p className="mt-1 mb-0">Referred By: {cmProfile?.referred_by}</p>
                                                                    <p className="mt-1 mb-0">Emergency Contact Name / Number: {cmProfile?.emergency_contact_person} / {cmProfile?.emergency_contact_no}</p>

                                                                    {!isWaiver ?
                                                                        <p className="mt-1 mb-0">Waiver:
                                                                            <input className="ml-2" style={{ cursor: "pointer" }} type="checkbox" checked={isWaiver}
                                                                                onClick={(e) => waiverHandler(e)}
                                                                            />
                                                                        </p>
                                                                        :
                                                                        <p className="mt-1 mb-0">Waiver:
                                                                            <input className="ml-2" type="checkbox" style={{ cursor: "pointer" }} checked={isWaiver} readOnly />
                                                                        </p>
                                                                    }
                                                                    {(selectMemberId == 0) &&
                                                                        <div>
                                                                            <button className="btn btn-brandblue mt-1" data-toggle="modal"
                                                                                data-target="#EditProfile" id="btn_close21" data-backdrop="static"
                                                                                data-keyboard="false"
                                                                                onClick={() => { setEditProfileModal(true) }}
                                                                            >Edit Profile</button>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <CustomerCloverCards
                                                cloverCards={cloverCards}
                                                getCustomerCloverCard={getCustomerCloverCard}
                                                getProfile={getProfile}
                                                child_ID={child_ID}
                                                user_id={cmProfile.id}
                                                studioData={studioData}
                                            />

                                            <FamilyMember
                                                setImgURL={setImgURL}
                                                selectMemberId={selectMemberId}
                                                cmProfile={cmProfile}
                                                getCustomerCloverCard={getCustomerCloverCard}
                                                studioData={studioData}
                                                setLoader={setLoader}
                                                freePass={freePass}
                                                logo={logo}
                                                getProfile={getProfile}
                                                viewFamilyPass={viewFamilyPass}
                                                setChild_ID={setChild_ID}
                                                resetFamilyPass={resetFamilyPass}
                                                update={update}
                                                newFamilyAdd={newFamilyAdd}
                                                familyWaiver={familyWaiver}
                                            />

                                            <div className="row">
                                                <div className="col-xl-12">
                                                    <div className="right-productdetail-sec p-4 relative mt-5">
                                                        <h4 className="title text-capitalize mt-5">Attendance</h4>
                                                        {selectMemberId == 0 &&
                                                            <div>
                                                                <ParentsAttendance
                                                                    ViewDetail={ViewDetail}
                                                                    parentsAttendance={parentsAttendance}
                                                                />
                                                                <ParentPurchasedProducts
                                                                    cmProfile={cmProfile}
                                                                />

                                                                {console.log("--------", purchasePunchCardPassRecurring)}
                                                                <ParentActivePurchasedPasses
                                                                    studioData={studioData}
                                                                    logo={logo}
                                                                    changeStatus={changeStatus}
                                                                    purchaseRecurringPass={purchaseRecurringPass}
                                                                    purchaseTimeFramePass={purchaseTimeFramePass}
                                                                    purchasePunchCardPassRecurring={purchasePunchCardPassRecurring}
                                                                    purchasePunchCardPass={purchasePunchCardPass}
                                                                    changePassInfo={changePassInfo}
                                                                    checkCardExpire={checkCardExpire}
                                                                    setPunchConfirmShow={setPunchConfirmShow}
                                                                />

                                                                <ParentInActivePurchasedPasses
                                                                    purchaseRecurringInactiveCard={purchaseRecurringInactiveCard}
                                                                    purchaseTimeFrameInactiveCard={purchaseTimeFrameInactiveCard}
                                                                    purchasePunchInactiveCard={purchasePunchInactiveCard}
                                                                    purchasePunchInactiveCardRecurring={purchasePunchInactiveCardRecurring}
                                                                    studioData={studioData}
                                                                    logo={logo}
                                                                    changeStatus={changeStatus}
                                                                    changePassInfo={changePassInfo}
                                                                    checkCardExpire={checkCardExpire}
                                                                    setPunchConfirmShow={setPunchConfirmShow}
                                                                />

                                                            </div>
                                                        }

                                                        {selectMemberId != 0 &&
                                                            <div >
                                                                <MemberAttendance
                                                                    ViewDetail={ViewDetail}
                                                                    familyUserDetail={familyUserDetail}
                                                                />
                                                                <MemberPurchasedProducts
                                                                    familyProductItems={familyProductItems}
                                                                />
                                                                <MemberActivePurchasedPasses
                                                                    logo={logo}
                                                                    familyRecurringItems={familyRecurringItems}
                                                                    familyTimeFrameItems={familyTimeFrameItems}
                                                                    familyPunchItems={familyPunchItems}
                                                                    familyRecurringActivePunch={familyRecurringActivePunch}
                                                                    studioData={studioData}
                                                                    changeStatus={changeStatus}
                                                                    changeExPassInfo={changeExPassInfo}
                                                                    checkCardExpire={checkCardExpire}
                                                                    changePassInfo={changePassInfo}
                                                                />

                                                                <MemberInActivePurchasedPasses
                                                                    familyRecurringInactiveItem={familyRecurringInactiveItem}
                                                                    familyTimeFrameInactiveItem={familyTimeFrameInactiveItem}
                                                                    familyPunchInactiveItem={familyPunchInactiveItem}
                                                                    familyRecurringInActivePunch={familyRecurringInActivePunch}
                                                                    studioData={studioData}
                                                                    checkCardExpire={checkCardExpire}
                                                                    changeStatus={changeStatus}
                                                                    changePassInfo={changePassInfo}
                                                                />
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                                <Footer />
                            </div>
                        </Col>
                    </Row >
                </div >
            </div >


            {/* <!-- Modal Popup (Add & Update - Family Member ) --> */}
            < Modal show={updateModal} className="modal fade" role="dialog" >
                <div className="modal-body white-bg box-shadow1 border-radius6 px-4 pb-4 px-md-5 pb-md-5">
                    <div className="modal-logo text-center pb-3 pb-sm-2 mb-2">
                        <input type="file" id="file1" name="image" style={{ height: '100px' }} accept="image/*" className="fileType"
                            onChange={(e) => getUploadFileDetail(e)} />
                        {!imgURL && <img src="assets/images/logo_white_web.png" className="img-fluid modalProfileImg m-0" />}
                        {imgURL && <img src={imgURL} alt="" className="img-fluid m-0 modalProfileImg" />}
                    </div>
                    <div className="modal-bottom-content border-radius6 py-3 py-sm-2 px-2">
                        <form className="AddNewForm" onSubmit={addMembers}>
                            <input type="hidden" name='memeber_id' value={memberDetail1My.memeber_id} />
                            <div className="form-group profile-change-password">
                                <p className="text-left font-14 mb-0"> Full Name </p>
                                <input type="text" className="form-control" value={memberDetail1My.member_name}
                                    placeholder="Full Name" name="member_name" onChange={(e) => faminlyOnChange(e)}
                                />
                                <small className="text-danger">{memberDetail1MyError.member_name}</small>
                            </div>

                            <div className="form-group">
                                <p className="text-left font-14 mb-0"> DOB </p>
                                <div >
                                    {memberDetail1My.memeber_id ?
                                        <input type="date" className="matinput" style={{ width: '100%', margin: '0', padding: '10px' }}
                                            value={memberDetail1My.dob}
                                            name="dob" readOnly={memberDetail1My.dob ? true : false} />
                                        :
                                        <input type="date" className="matinput" style={{ width: '100%', margin: '0', padding: '10px' }}
                                            value={memberDetail1My.dob}
                                            max={moment().format(' MMMM DD, YYYY')}
                                            name="dob" onChange={(e) => faminlyOnChange(e)}
                                        />
                                    }
                                </div>
                            </div>
                            <small className="text-danger">{memberDetail1MyError.dob}</small>

                            <div className="form-group relative">
                                <p className="text-left font-14 mb-0"> Gender </p>
                                <select className="form-control white-color" name="gender"
                                    value={
                                        memberDetail1My.gender
                                            ? memberDetail1My.gender.charAt(0).toUpperCase() +
                                            memberDetail1My.gender.slice(1).toLowerCase()
                                            : ""
                                    }
                                    onChange={(e) => faminlyOnChange(e)} >
                                    <option value=""> </option>
                                    <option value="Male" selected={memberDetail1My.gender === 'Male'}>Male</option>
                                    <option value="Female" selected={memberDetail1My.gender === 'Female'}>Female</option>
                                    <option value="Other" selected={memberDetail1My.gender === 'Other'}>Other</option>
                                </select>
                                <small className="text-danger">{memberDetail1MyError.gender}</small>
                            </div>

                            <div className="form-group relative">
                                <p className="text-left font-14 mb-0"> Relation with me </p>
                                <select className="form-control white-color" name="relation" onChange={(e) => faminlyOnChange(e)}>
                                    <option value=""> </option>
                                    {relationCollection && relationCollection.map((rl) => (
                                        <option value={rl.relative_id} selected={relationIds === rl.relative_id}>{rl.realtion_name}</option>

                                    ))}
                                </select>
                                <small className="text-danger">{memberDetail1MyError.relation}</small>
                            </div>

                            <div className="form-group text-align-center px-3 pt-0 pt-sm-2 mb-0 mb-sm-2 d-flex">
                                {!memberDetail1My.memeber_id &&
                                    <button type="submit" className="btn btn-brandblues text-capitalize  ml-5">
                                        {memberSpinner && <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>}
                                        Save
                                    </button>}
                                {memberDetail1My.memeber_id &&
                                    <button type="submit" variant="primary" className="btn btn-brandblues text-capitalize  ml-5">
                                        {memberSpinner && <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>}
                                        Update
                                    </button>}
                                <button type="button" data-dismiss="modal" id="btn_close1"
                                    className="btn btn-brandblues text-capitalize ml-5" data-backdrop="static"
                                    data-keyboard="false"
                                    onClick={() => setUpdateModal(false)}> close </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal >

            {/* <!-- Modal Popup (View - Attandance ) --> */}
            < Modal show={showModalAttendance} className="modal fade" >
                <div className="modal-body white-bg box-shadow1 border-radius6 px-4 pb-4 px-md-5 pb-md-5">
                    <button type="button" onClick={() => setShowModalAttendance(false)} data-dismiss="modal" id="class_modal_close_btn1" className="float-right mb-5">
                        <img src="assets/images/icons/close.png" width="15" /></button>
                    <div className="col-12">
                        <h4 className="black-color font-w-400 font-18 mb-0 text-capitalize mt-5">Last 30 day Vs Prior 30 days
                            Attendance is :
                            {summaryData && summaryData.attendance_status == 1 &&
                                <span className="brand-green font-18 ml-5">{summaryData.description} </span>}
                            {summaryData && summaryData.attendance_status == 0 &&
                                <span className="brand-red font-18 ml-5"> {summaryData && summaryData.description ? summaryData.description : ''} </span>}
                        </h4>
                        <h4 className="black-color font-w-400 font-18 mb-0 text-capitalize mt-4 mb-2">Summary: </h4>
                        <p className="black-color  font-16">{summaryData && summaryData.current_month ? summaryData.current_month : ''}</p>
                        <p className="black-color  font-16"> {summaryData && summaryData.previous_month ? summaryData.previous_month : ''} </p>
                    </div>
                </div>
            </Modal >

            {/* <!-- Update Pass Counter --> */}
            < Modal show={countModal} className="modal"  >
                {/* <!-- Modal Header --> */}
                {selectPassType == 'Punch Card' &&
                    < div className="modal-header" >
                        <h4 className="modal-title">Update Pass Counter</h4>
                        <button type="button" className="close" onClick={() => setCountModal(false)} data-dismiss="modal">&times;</button>
                    </div >
                }
                {selectPassType == 'Time Frame' &&
                    < div className="modal-header" >
                        <h4 className="modal-title">Update Pass Date</h4>
                        <button type="button" className="close" onClick={() => setCountModal(false)} data-dismiss="modal">&times;</button>
                    </div >
                }
                {/* <!-- Modal body --> */}
                < div className="modal-body" >
                    {selectPassType == 'Punch Card' &&
                        <div className="row">
                            <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                <div className="form-group">
                                    <p className="black-color font-w-900 text-left font-18 mb-0 ml-2 pl-1">Total Count</p>
                                    <input type="number" className="form-control text-capitalize" value={total_count}
                                        onChange={(e) => setTotal_count(e.target.value)}
                                        placeholder="Enter total count"

                                    />
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                <div className="form-group">
                                    <p className="black-color font-w-900 text-left font-18 mb-0 ml-2 pl-1">Remaining Count</p>
                                    <input type="number" className="form-control text-capitalize" value={remaining_count}
                                        placeholder="Enter remaining count"
                                        onChange={(e) => setRemaining_count(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    {
                        selectPassType == 'Time Frame' &&
                        <div className="row">
                            <div className="col-12 col-sm-6">
                                <div className="form-group">
                                    <p className="black-color font-w-900 font-18 mb-2">Expiry Date</p>
                                    <input
                                        type="date"
                                        className="form-control"
                                        onChange={(e) => setSelectPassExpiry(e.target.value)}
                                        value={selectPassExpiry}
                                        required
                                    />
                                </div>
                            </div>
                        </div >
                    }
                </div >
                <div className="modal-footer">
                    <button type="button" className="btn btn-danger" onClick={() => setCountModal(false)} data-dismiss="modal">Close</button>
                    <button type="button" className="btn btn-primary"
                        onClick={() => updatePassCounter()} >
                        Submit
                        {punchCardSpinner && <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>}
                    </button >
                </div >
            </Modal >

            {/* <!-- Extand punch pass date --> */}
            < Modal show={passEXPState} className="modal"  >
                <div className="modal-header">
                    <h4 className="modal-title">Update Pass Date</h4>
                    <button type="button" onClick={() => setPassEXPState(false)} className="close" data-dismiss="modal">&times;</button>
                </div>
                <div className="modal-body">
                    {selectPassType === 'Punch Card' &&
                        <div div className="row" >
                            <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                <div className="form-group">
                                    <p className="black-color font-w-900 text-left font-18 mb-0 ml-2 pl-1">Expiry Date</p>
                                    <InputField
                                        type="date"
                                        onChange={(e) => setPassEditDate(e.target.value)}
                                        value={passEditDate}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                    }
                </div >
                <div className="modal-footer">
                    <button type="button" className="btn btn-danger" onClick={() => setPassEXPState(false)} data-dismiss="modal">Close</button>
                    <button type="button" className="btn btn-primary"
                        onClick={() => updatePassDate()} > Submit
                        {punchCardSpinner && <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>}
                    </button >
                </div >
            </Modal >

            {/* <!-- Extand punch pass date --> */}
            <Modal show={notclose} className="modal">
                <div className="modal-header">
                    <h4 className="modal-title">Update Expiration Date</h4>
                    <button type="button" onClick={() => setNotclose(false)} className="close" data-dismiss="modal">&times;</button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-12 col-sm-6 mt-2 mt-md-3">
                            <div className="form-group">
                                <p className="black-color font-w-900 text-left font-18 mb-0 ml-2 pl-1">Expiry Date</p>
                                <InputField
                                    type="date"
                                    onChange={(e) => setPassEditDate(e.target.value)}

                                    required
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-danger" onClick={() => setNotclose(false)} data-dismiss="modal">Close</button>
                    <button type="button" className="btn btn-primary" onClick={updateExPassDate}>
                        Submit
                    </button>
                </div >
            </Modal >

            {/* <!-- Modal Popup (Edit - Profile ) --> */}
            <Modal show={editProfileModal} size="lg">
                <div className="modal-body white-bg box-shadow1 border-radius6 px-4 pb-4 px-md-5 pb-md-5">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 pb-4">
                                <div className="profile-details">
                                    <div className="row align-items-center">
                                        <div className="col-12 col-md-6">
                                            <div className="profile-detail-image ">
                                                <div className="userprofile_img box-shadow1">
                                                    {!imgURL ?
                                                        <img src={cmProfile && cmProfile.profile_img} className="img-fluid border-radius100 w-100" style={{ height: "200px" }} />
                                                        :
                                                        <img src={imgURL} className="img-fluid border-radius100  w-100" style={{ height: "200px" }} />
                                                    }
                                                    <a href="Javascript:void(0);" className="brand-color1 font-14 edit-profileimg box-shadow1"
                                                        id="upfile1" style={{ cursor: "pointer" }}>
                                                        <i className="fas fa-camera">
                                                            <input type="file" id="file1" name="image" accept="image/*" onChange={(e) => getUploadFileDetail(e)} />
                                                        </i>
                                                    </a>

                                                </div>
                                            </div>
                                        </div>
                                        {cmProfile &&
                                            <div className="col-12 col-md-6">
                                                <div className="profile-detail-text">
                                                    <h2 className="title dark-color font-24 mb-2 text-capitalize">
                                                        {cmProfile?.name}  </h2>
                                                    <h3>{cmProfile?.lastName} </h3>
                                                    <p className="brand-color3">  {cmProfile?.email} </p>

                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            {/* <!-- Client Details --> */}

                            <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                <div className="form-group">
                                    <p className="black-color font-w-900 text-left font-18 mb-0 ml-2 pl-1">First Name </p>
                                    <input type="text" className="form-control text-capitalize"
                                        value={cmProfile.name}
                                        placeholder="Enter your name"
                                        onChange={prOnChange}
                                        name="name" />
                                    <small className="text-danger">{eFormData.name}</small>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                <div className="form-group">
                                    <p className="black-color font-w-900 text-left font-18 mb-0 ml-2 pl-1">Last Name </p>
                                    <input id="" type="text" name="lastName" className="form-control text-capitalize"
                                        value={cmProfile.lastName}
                                        placeholder="Enter your name"
                                        onChange={prOnChange}
                                    />
                                    <small className="text-danger">{eFormData.lastName}</small>
                                </div>
                            </div>
                            {/* <!-- Name --> */}

                            <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                <div className="form-group">
                                    <p className="black-color font-w-900 text-left font-18 mb-0 ml-2 pl-1">Country Code</p>
                                    <select className="form-control" name="country_code" value={cmProfile.country_code} onChange={prOnChange} >
                                        {countryList && countryList.map((co) => (<option value={co.code} >{co.name}</option>))}
                                    </select>
                                    <small className="text-danger">{eFormData.country_code}</small>
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                <div className="form-group">
                                    <p className="black-color font-w-900 text-left font-18 mb-0 ml-2 pl-1"> Phone </p>
                                    <input id="" type="number" name="mobile" className="form-control"
                                        value={cmProfile.mobile}
                                        onChange={prOnChange}
                                        style={{ backgroundColor: "white" }} placeholder="Enter your phone no."
                                    />
                                    <small className="text-danger">{eFormData.mobile}</small>
                                </div>
                            </div>
                            {/* <!-- Phone --> */}

                            <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                <div className="form-group">
                                    <p className="black-color font-w-900 text-left font-18 mb-0 ml-2 pl-1"> Email </p>
                                    <input id="" type="email" name="email" className="form-control" readOnly
                                        value={cmProfile.email}
                                        style={{ backgroundColor: "white" }} placeholder="Enter your e-mail" />
                                </div>
                            </div>

                            {/* <!-- Email --> */}

                            <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                <div className="form-group">
                                    <p className="black-color font-w-900 text-left font-18 mb-0 ml-2 pl-1"> DOB </p>
                                    <InputField
                                        type="date"
                                        name={'date_of_birth'}
                                        onChange={prOnChange}
                                        value={cmProfile.date_of_birth}
                                    />
                                    <small className="text-danger">{eFormData.date_of_birth}</small>
                                </div>
                            </div>
                            {/* // <!-- DOB --> */}

                            <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                <div className="form-group">
                                    <p className="black-color font-w-900 text-left font-18 mb-0 ml-2 pl-1"> Address</p>
                                    <PlaceAutoCompleted setCordinates={setCoordinates} myClassName="form-control" />
                                    {/* <input id="" name="address" className="form-control"
                                            value={cmProfile.address}
                                            placeholder="Enter your address"
                                            onChange={prOnChange}
                                        /> */}
                                    <small className="text-danger">{eFormData.address}</small>

                                </div>
                            </div>
                            {/* <!-- Address --> */}

                            <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                <div className="form-group">
                                    <p className="black-color font-w-900 text-left font-18 mb-0 ml-2 pl-1"> Country </p>
                                    <input id="" name="country" className="form-control"
                                        value={cmProfile.country}
                                        onChange={prOnChange}
                                        placeholder="Enter your country"
                                    />
                                    <small className="text-danger">{eFormData.country}</small>
                                </div>
                            </div>
                            {/* // ><!-- Country --> */}

                            <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                <div className="form-group">
                                    <p className="black-color font-w-900 text-left font-18 mb-0 ml-2 pl-1"> State/Province
                                    </p>
                                    <input id="" name="state" className="form-control"
                                        value={cmProfile.state}
                                        onChange={prOnChange}
                                        placeholder="Enter your state/province"
                                    />
                                    <small className="text-danger">{eFormData.state}</small>
                                </div>
                            </div>
                            {/* <!-- State/Province --> */}

                            <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                <div className="form-group">
                                    <p className="black-color font-w-900 text-left font-18 mb-0 ml-2 pl-1"> City </p>
                                    <input id="" name="city" className="form-control"
                                        value={cmProfile.city}
                                        onChange={prOnChange}
                                        placeholder="Enter your city"
                                    // [ngClass]="{ 'is-invalid': submitted && pf.city.errors }"
                                    />
                                    <small className="text-danger">{eFormData.city}</small>
                                </div>
                            </div>
                            {/* <!-- City --> */}

                            <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                <div className="form-group">
                                    <p className="black-color font-w-900 text-left font-18 mb-0 ml-2 pl-1"> Emergency
                                        Contact Person </p>
                                    <input id="" name="emergency_contact_person" className="form-control"
                                        value={cmProfile.emergency_contact_person}
                                        onChange={prOnChange}
                                        placeholder="Enter name of your emergency contact person"
                                    />
                                    <small className="text-danger">{eFormData.emergency_contact_person}</small>
                                </div>
                            </div>
                            {/* <!-- Emergency Contact Person --> */}
                            <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                <div className="form-group">
                                    <p className="black-color font-w-900 text-left font-18 mb-0 ml-2 pl-1"> Emergency
                                        Country </p>
                                    <select className="form-control"
                                        name="emergency_country_code"
                                        onChange={prOnChange}
                                        required>
                                        <option value=" "></option>
                                        {countryList && countryList.map((code) => (
                                            <option selected={cmProfile.emergency_country_code === code.code} value={code.code}>{code.name}
                                            </option>))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                <div className="form-group">
                                    <p className="black-color font-w-900 text-left font-18 mb-0 ml-2 pl-1"> Emergency
                                        Contact Number </p>
                                    <input type="number" name="emergency_contact_no" className="form-control"
                                        value={cmProfile.emergency_contact_no}
                                        onChange={prOnChange}
                                        placeholder="Enter number of your emergency contact person"
                                    />
                                    <small className="text-danger">{eFormData.emergency_contact_no}</small>
                                </div>
                            </div>
                            {/* <!-- Emergency Contact Number --> */}

                            <div className="col-12 col-sm-8 mt-2 mt-md-3">
                                <div className="form-group profile-gender mb-0">
                                    <p className="brand-color3 text-left font-14 mb-3"> Gender </p>
                                    <div className="profile-gender-button2">
                                        <input type='radio' id='male' checked={cmProfile.gender === "male"} value="male" name='gender'
                                            onChange={prOnChange}
                                        />
                                        <label for='male'>Male</label>
                                        <input type='radio' id='female' value="female" name='gender'
                                            checked={cmProfile.gender === "female"}
                                            onChange={prOnChange}
                                        />
                                        <label for='female'>Female</label>

                                        <input type='radio' id='other' value="other" name='gender'
                                            checked={cmProfile.gender === "other"}
                                            onChange={prOnChange}
                                        />
                                        <label for='other'>Other</label>
                                    </div>
                                    {/* <!-- end of profile-gender-button2 --> */}
                                </div>
                            </div>
                            {/* <!-- Gender --> */}

                            <div className="col-12 col-sm-4 mt-2 mt-md-3"></div>
                            <div className="col-12 col-sm-4 mt-2 mt-md-3"></div>

                            <div className="col-12 col-sm-4 mt-2 mt-md-3 d-flex">
                                <button type="submit" variant="primary" className="btn btn-brandblue mt-5 mr-3 text-right" onClick={() => updateProfileHandler()}>
                                    Update
                                </button>
                                <button type="button" data-dismiss="modal" id="btn_close11" className="btn btn-brandblue mt-5 mr-3 text-right" data-backdrop="static"
                                    data-keyboard="false" onClick={() => setEditProfileModal(false)}
                                > close </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal >

            {/* Show Pause Modal */}
            < Modal show={show && modalContent === 'default'
            } onHide={handleClose} className="MembershipActiveModal" >
                <Modal.Header closeButton>
                    {['36', '37'].includes(recurringPassObj?.pass_type_subcat) ? (
                        <Modal.Title>Pause or Cancel Membership</Modal.Title>
                    ) :
                        <Modal.Title>Cancel Membership</Modal.Title>
                    }
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            {['36', '37'].includes(recurringPassObj?.pass_type_subcat) && (
                                <p>
                                    Would you like to : <Button variant="warning" onClick={() => handleButtonClick('Pause')} className="mx-3">Pause</Button> the pass for 30 days or less
                                </p>
                            )}
                            <p>
                                Would you like to : <Button variant="danger" onClick={() => handleButtonClick('Cancel')} className="mx-3">Cancel</Button> this pass
                            </p>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col md={12}>
                            <p>
                                <b>Note:</b>
                                To adjust the next recurring pass charge, go to “Paused Recurring Pass Billing” in the reports tab
                            </p>
                        </Col>
                        {/* <Col md={2}>
                            <Button variant="danger" onClick={handleClose}> No </Button>
                        </Col> */}
                    </Row>
                </Modal.Footer>
            </Modal >

            {/*  Punch card cancelation model */}
            < Modal
                show={punchConfirmShow.status && modalContent === 'default'}
                onHide={() => { setPunchConfirmShow({ status: false, data: "", isChild: false }) }}
                className="MembershipActiveModal" >
                <Modal.Header closeButton>
                    <Modal.Title>Cancel Membership</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <p>
                                Would you like to : <Button variant="danger" onClick={() => {
                                    stopRecuringHandler(punchConfirmShow.data, punchConfirmShow.isChild);
                                    setPunchConfirmShow((prev) => ({
                                        ...prev,
                                        status: false,
                                    }));
                                }} className="mx-3">Cancel</Button> this pass
                            </p>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col md={12}>
                            <p>
                                <b>Note:</b>
                                The pass will remain active until the end of the current billing period and will not renew afterward.
                            </p>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal >

            {/* Pause Modal */}
            < Modal show={show && modalContent === 'pause'
            } onHide={handleClose} className="MembershipActiveModal" >
                <Modal.Header closeButton>
                    <Modal.Title>Pause Membership</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <p>Enter the details to pause the pass:</p>
                            {recurringPassObj && recurringPassObj.pass_pause_start_less_then_thirty == '' ?
                                <Row>
                                    <Col>
                                        <InputField
                                            type="date"
                                            name={'pauseStartDate'}
                                            minLength={(moment().add(1, 'days')).format(' MMMM DD, YYYY')}
                                            lable='Pause Start Date'
                                            onChange={changeHandlerPause}
                                        />
                                        <small className="text-danger">{pauseCaseValueError.pauseStartDate}</small>
                                    </Col>
                                    <Col>
                                        <InputField
                                            type="number"
                                            minLength={'0'}
                                            name={'days'}
                                            onChange={changeHandlerPause}
                                            lable={'Days Paused (must be less than 30 days)'}
                                        // lable='Days Paused: (must be less than 30 days)'
                                        />
                                        <small className="text-danger">{pauseCaseValueError.days}</small>
                                    </Col>
                                </Row>
                                :
                                <Row>
                                    <Col>
                                        <InputField
                                            type="date"
                                            value={recurringPassObj && recurringPassObj.pass_pause_start_less_then_thirty}
                                            lable='Pause Start Date'
                                            readOnly={true}
                                            onChange={changeHandlerPause}
                                        />
                                    </Col>
                                    <Col>
                                        <InputField
                                            className={'form-control abcd'}
                                            type="date"
                                            name={'pauseEndDate'}
                                            onChange={changeHandlerPause}
                                            minLength={recurringPassObj && moment(recurringPassObj.pass_pause_start_less_then_thirty).add(1, 'days').format(' MMMM DD, YYYY')}
                                            // max={recurringPassObj && moment(recurringPassObj.pass_pause_start_less_then_thirty).format('M MMM DD, YYYY')}
                                            lable={'Pass Restart Date'}
                                        // lable={`pauseReason [ ${recurringPassObj && moment(recurringPassObj.pass_pause_start_less_then_thirty).format('DD-MM-YYYY')} ]`}
                                        />
                                        <small className="text-danger">{pauseCaseValueError.pauseEndDate}</small>
                                    </Col>
                                </Row>
                            }

                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col md={9}>
                            <p>
                                <b>Note:</b>
                                To adjust the next recurring pass charge, go to “Paused Recurring Pass Billing” in the reports tab
                            </p>
                        </Col>
                        <Col md={3}>
                            <Row>
                                <h5>Save Changes</h5>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Button variant="primary" className="pt-1 pb-1 pl-2 pr-2 mr-2" onClick={confirmMultipleResponse}> Yes </Button>
                                </Col>
                                <Col md={6}>
                                    <Button variant="danger" onClick={handleClose}>  No </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal >

            {/* Cancel Modal */}
            < Modal show={show && modalContent === 'cancel'} onHide={handleClose} className="MembershipActiveModal" >
                <Modal.Header closeButton>
                    <Modal.Title><p className="text-danger">Cancelling Recurring Pass</p></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modalContent === 'cancel' && (
                        <Row>
                            <Col>
                                <h3>This action is not reversible. </h3>
                                {/* <p>
                                    By cancelling this pass, it will become inactive at the end of the month and move the pass to become inactive.
                                    The client can use this pass until the end of the month. Do you want to proceed with cancelling this?
                                </p> */}
                                <p>By cancelling this pass it will become inactive at the end of the month.
                                    The client can use this pass until the end of the month.
                                </p>
                                <p>Do you want to proceed with cancelling this pass?</p>
                            </Col>
                        </Row>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col md={12}>
                            <Row>
                                <Col md={12}>
                                    <h5>Save Changes</h5>
                                    <Row>
                                        <Col md={6}>
                                            <Button variant="primary" className="pt-1 pb-1 pl-2 pr-2 mr-2" onClick={cancelPausePass}> Yes </Button>
                                        </Col>
                                        <Col md={6}>
                                            <Button variant="danger" onClick={handleClose}>  No </Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal >



            {/* Add Card Modal */}
            < AddCardModalNew
                showCardModal={showCardModal}
                setShowCardModal={setShowCardModal}
                clientIDS={searchID}
                child_ID={child_ID}
                studioData={studioData}
                setLoder={setLoader}
                getCustomerCloverCard={getCustomerCloverCard}
            />

        </ >
    )
}
